import React, { useEffect, useState } from 'react';

const Toast = () => {
    const [toast, setToast] = useState({ type: '', message: '', visible: false });

    useEffect(() => {
        let dismissTimer;
        const showToast = (type, message, duration = 2000) => {
            clearTimeout(dismissTimer);
            setToast({ type, message, visible: true });
            dismissTimer = setTimeout(() => {
                setToast({ type: '', message: '', visible: false });
            }, duration);
        };

        window.showToast = showToast;
        return () => {
            clearTimeout(dismissTimer);
            if (window.showToast === showToast) delete window.showToast;
        };
    }, []);

    if (!toast.visible) return null;

    return (
        <div role={toast.type === 'error' ? 'alert' : 'status'} className={`custom-toast ${toast.type === 'error' ? 'toast-error' : 'toast-success'}`}>
            <div className="toast-body">{toast.message}</div>
        </div>
    );
};

export default Toast;
